import useMemoryLogger from '../../hooks/useMemoryLogger/useMemoryLogger';

const MemoryLogger = () => {
    useMemoryLogger();

    return '';
};

export default MemoryLogger;
